// extracted by mini-css-extract-plugin
export default {"list":"X1bm3","item":"rhsY7","itemContent":"YZOfF","itemIcon":"_iPiw","itemLabel":"vBtNj","addingText":"y4hHD","arrow":"B1NUu"};